<template>
  <list-layout :tableTools="false">
    <template slot="header" >
      <div class="px-4 lg:px-10 font-medium dark:text-white mb-2 flex gap-4 items-center">
        <h2>{{ $t('products.header') }}</h2>
        <el-form-item prop="products" class="flex-1">
        </el-form-item>
      </div>
    </template>
    <template slot="table-core">
      <base-table-pagination 
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row space-x-2">
        <base-button-responsive size="xs" class="w-full md:w-auto" icon="plus" :text="$t('invoices.invoices_issuing.step4.create_product')" @click="goPorductCreation" :loading="isGeneralLoading" />
        <div class="flex flex-row w-100 gap-4">
          <base-table-search @toggleFilters="toggleFilters" />
        </div>
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags hide-save :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component 
        :value="value"
        value-key="idProducto"
        value-type="data-item"
        :spanish="spanish"
        :data="data"
        :kendo="kendo"
        :loading="isGeneralLoading"
        :selectedField="selectedField"
        :inEditField="selectedField"
        :expandField="selectedField"
        :update-columns="false"
        @input="$emit('input', $event)"
        @datastatechange="dataStateChange">
          <template v-slot:kendorowdetail="{ scope, selected, inEdit, save }">
            <div class="custom-detail-row flex flex-row gap-2 w-full">
              <div class="flex flex-col gap-2 w-full">
                <div class="w-full flex flex-row gap-2">
                  <div class="flex flex-row gap-2 w-full">
                    <div class="w-full">
                      <div>
                        <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="selected" />{{ $t('invoices.invoices_issuing.step4.cantidad') }}</label>
                        <el-input clearable class="w-full" v-model="scope.cantidad" type="number" size="mini" :disabled="!inEdit" @input="controlCantidad(scope, $event, save)" />
                      </div>
                      <base-ro-input class="mt-2" mini :label="$t('app.subtotal')" :data="formatNumberWithDefault(scope.subtotal)" />
                    </div>
                    <div class="w-full">
                      <div>
                        <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.descuento_long') }}</label>
                        <el-input clearable class="w-full" v-model="scope.descuento" type="number" size="mini" :disabled="!inEdit" @input="controlDescuento(scope, $event, save)" />
                      </div>
                      <div class="mt-2">
                        <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.discount_cuota') }}</label>
                        <el-input clearable class="w-full" v-model="scope.cuota" type="number" size="mini" :disabled="!inEdit" @input="controlCuota(scope, $event, save)" />
                      </div>
                    </div>
                  </div>
                  <div class="w-full">
                    <div class="flex flex-row gap-2">
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="selected" />{{ $t('impuestos.entity_name') }}</label>
                        <!-- Quitar [0], cambiar [e] por e y agregar atributo múltiple para admitir varios impuestos -->
                        <base-el-select v-if="!hasOperationType" clearable class="w-full" v-model=scope.Taxes[0] size="mini" value-key="idImpuesto" :option-value="taxValue" :options="scope.Impuestos" :disabled="!inEdit || hasOperationType" @input="controlImpuestos(scope, [$event], save)" />
                        <base-el-select v-else clearable class="w-full" v-model=zeroTax[0] size="mini" value-key="idImpuesto" :option-value="taxValue" :options="zeroTax" :disabled="hasOperationType" @input="controlImpuestos(scope, [$event], save)" />
                      </div>
                      <div class="w-full">
                        <base-ro-input class="flex-1" mini :label="$t('app.total_no_tax')" :data="formatNumberWithDefault(scope.total)" />
                      </div>
                    </div>
                    <div class="flex flex-row gap-2 mt-2">
                      <base-ro-input class="flex-1" mini :label="$t('invoices.invoices_issuing.tax_cuota')" :data="formatNumberWithDefault(hasOperationType ? 0 : scope.Taxes[0].cuota)" />
                      <base-ro-input class="flex-1" mini :label="$t('app.total')" :data="formatNumberWithDefault(scope.totalConImpuesto)" />
                    </div>
                  </div>
                </div>
                <div class="w-full">
                  <div class="w-full">
                    <!-- <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.observaciones') }} ({{ (scope.additionalLineItemInformation || '').length }} {{ $t('app.of') }} {{ additionalLineItemInformationMaxLength }})</label> -->
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.observaciones') }}</label>
                    <el-input clearable class="w-full" v-model="scope.additionalLineItemInformation" type="textarea" :rows="2" resize="none" :maxlength="additionalLineItemInformationMaxLength" show-word-limit size="mini" :disabled="!inEdit" @input="save" />
                  </div>
                </div>
              </div>
            </div>
          </template>
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog :numberSearches="numberSearches" :idVista="idVista" :dialogOpen="saveSearchDialog"
        :tags="tags" @toggleDialog="toggleDialogSearches" @applyDialog="applySearchHandler" />
    </template>
  </list-layout>
</template>
<script>
import { i18n } from '@/i18n'

import getNestedValue from '@/services/functions/getNestedValue'
import setNestedValue from '@/services/functions/setNestedValue'
import { getProductsWithTaxesPag } from '@/services/configurations/getProductsWithTaxesPag'

import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/Step4ProductsFilter.vue'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'


export default {
  name: 'step4-product-table',
  components: {
    // Loading,
    ListLayout,
    FilterPanel,
    KendoGridComponent,
    CreateSearchDialog,
  },
  props: {
    value: Array,
    ruleForm: Object,
    idCliente: [Number, String]
  },
  data () {
    return {
      // Searches
      idVista: 66,
      numberSearches: 0,
      saveSearchDialog: false,
      // All
      spanish: true,
      vuexnamespace: 'invoicesIssuing/4/products',
      selectedField: 'selected',
      filterPanel: false,
      loadingDataTable: false,
      additionalLineItemInformationMaxLength: '2500',
      data: [],
      selected: [],
      zeroTax: []
    }
  },
  computed: {
    hasOperationType: function () {
      return this.operationType === 1 || this.operationType === 2 || this.operationType === 3
    },
    operationType: function () {
      return this.$store.getters['invoicesIssuing/2/form']?.tipoImpuestoFactura
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading || this.loadingCompanies || this.loadingCompanyData || this.loadingContacts
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    tiposOperacion: function () {
      return this.$store.getters['config/TIPOS_OPERACION_TRIBUTACION'].filter(x => x.id === this.operationType)[0].name
    },
  },
  async mounted () {
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    this.data = await this.applyFilters()
    if (this.hasOperationType) {
      this.zeroTax.push({
        Name: this.tiposOperacion || this.operationType,
        TaxType: '01',
        TaxRate: 0,
        TaxCategory: 0,
        idImpuesto: -1
      })
    }
  },
  methods: {
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    getParamsFilter (data) {
      const params = {
        ItemDescription: data.ItemDescription ? data.ItemDescription.value : null,
        UnitOfMeasure: data.UnitOfMeasure ? data.UnitOfMeasure.value : null,
        UnitPriceWithoutTaxMin: data.UnitPriceWithoutTaxMin ? data.UnitPriceWithoutTaxMin.value : null,
        UnitPriceWithoutTaxMax: data.UnitPriceWithoutTaxMax ? data.UnitPriceWithoutTaxMax.value : null,
        ArticleCode: data.ArticleCode ? data.ArticleCode.value : null,
      }
      if (this.role !== '' && [3, 7, 8].includes(this.role)) {
        params.idCliente = this.idCliente || null
      }
      return params
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      this.$store.commit('setIsLoading', true)
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = this.getParamsFilter(data)
      const obj = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const data = await this.getItemsData(obj, params)
        return data
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
      return null
    },
    getItemsData: async function (orders, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(orders, params)
      const data = res.Respuesta
      data.forEach(this.initialiceProduct)

      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false

      if (pagination.currentPage > pagination.totalPages) {
        this.applyFiltersHandler()
      }

      return data
    },
    async getMainData (orders, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getProductsWithTaxesPag(orders, params)

      // Si no se marca exento, no sujeto o inv sujeto pasivo, no mostrar esos tipos de impuestos 
      // Condiciones (
      //  - Se llame Exento, No sujeto, Inversión sujeto pasivo
      //  - Tipo impositivo > 0
      // )

      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters()
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      try {
        this.data = await this.applyFilters()
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
    },
    removeFilterTagHanlder: async function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.data = await this.applyFilters()
    },
    headerCoreFiltersHandler: async function (obs) {
      if (this.isHeadCoreReady) {
        this.data = await this.applyFilters()
      }
    },
    removeAllTagsHandler: async function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.data = await this.applyFilters()
    },
    unselect: function () {
      this.$emit('input', [])
    },
    initialiceProduct: function (dataItem) {
      const selectedDataItem = this.value.find(x => x.idProducto === dataItem.idProducto);
      ['subtotal', 'descuento', 'cuota', 'total', 'totalConImpuesto'].forEach(key => {
        const currentValue = getNestedValue(key, dataItem)
        if (currentValue === undefined || currentValue === null) {
          setNestedValue(key, dataItem, selectedDataItem?.[key] || '', true)
        }
      })
      if (!dataItem.Taxes?.[0]) {
        setNestedValue('Taxes[0]', dataItem, selectedDataItem?.Taxes?.[0] || dataItem.Impuestos[0] || '', true)
      }
      if (dataItem.editDescuento === undefined || dataItem.editDescuento === null) {
        setNestedValue('editDescuento', dataItem, selectedDataItem?.editDescuento || false, true)
      }
      if (dataItem.cantidad === undefined || dataItem.cantidad === null) {
        setNestedValue('cantidad', dataItem, selectedDataItem?.cantidad || '1', true)
        this.controlCantidad(dataItem, dataItem.cantidad)
      }
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
    validate: function () {
      if (this.ruleForm) {
        this.ruleForm.validateField('products')
      }
    },
    controlCantidad: function (dataItem, cantidad, save) {
      if (this.isFalsy(cantidad)) {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.need_cantidad'))
      } else if (cantidad === 0) {
        cantidad = ''
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_cantidad'))
      } else if (cantidad.includes('.') && dataItem.UnitOfMeasure.includes('01')) {
        cantidad = ''
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_product'))
      }
      this.calculateSubTotal(dataItem, cantidad)
      if (dataItem.editDescuento && this.isNotFalsy(dataItem.descuento)) {
        this.controlDescuento(dataItem, dataItem.descuento, save)
      } else if (!dataItem.editDescuento && this.isNotFalsy(dataItem.cuota)) {
        this.controlCuota(dataItem, dataItem.cuota, save)
      } else {
        this.calculateTotal(dataItem)
        this.calculateTotalConImpuesto(dataItem, save) 
      }
    },
    controlCuota: function (dataItem, cuota, save) {
      var valid = true
      if (cuota !== '' && cuota !== 0 && dataItem.subtotal !== 0 && ((cuota < 0 && dataItem.subtotal > 0) || (cuota > 0 && dataItem.subtotal < 0))) {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_cuota', { max: dataItem.subtotal }))
        cuota = ''
        valid = false
      }
      const descuento = cuota !== '' && dataItem.subtotal !== '' ? cuota * 100 / dataItem.subtotal : ''
      setNestedValue('descuento', dataItem, descuento, true)
      setNestedValue('editDescuento', dataItem, (cuota !== '' ? false : (valid ? '' : null)), true)
      this.calculateTotal(dataItem)
      this.calculateTotalConImpuesto(dataItem, save)
    },
    controlDescuento: function (dataItem, descuento, save) {
      var valid = true
      if (descuento !== '' && (descuento < 0 || descuento > 100)) {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_discount'))
        descuento = ''
        valid = false
      }
      const cuota = descuento !== '' && dataItem.subtotal !== '' ? dataItem.subtotal * descuento / 100 : ''
      setNestedValue('cuota', dataItem, cuota, true)
      setNestedValue('editDescuento', dataItem, (descuento !== '' ? true : (valid ? '' : null)), true)
      this.calculateTotal(dataItem)
      this.calculateTotalConImpuesto(dataItem, save)
    },
    controlImpuestos: function (dataItem, taxes = [], save) {
      if (this.isFalsy(taxes) && getNestedValue(this.selectedField, dataItem) && this.isNotFalsy(dataItem.cantidad)) {
        this.doFeedback(i18n.t('feedback.error.obligatory_field_error', { field: i18n.t('impuestos.entity_name').toLowerCase() }))
      } 
      if (taxes.some(x => x.TaxRate === 0)) {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.warning_zero_tax_rate'), 'warning', 6000)
      }
      this.calculateTotalConImpuesto(dataItem, save)
    },
    calculateSubTotal: function (dataItem, cantidad = dataItem.cantidad) {
      if (this.isNotFalsy(cantidad)) {
        const subtotal = dataItem.UnitPriceWithoutTax * cantidad
        setNestedValue('subtotal', dataItem, subtotal, true)
      } else {
        setNestedValue('subtotal', dataItem, '', true)
      }
    },
    calculateTotal: function (dataItem) {
      if (this.isNotFalsy(dataItem.subtotal) && (dataItem.editDescuento !== null)) {
        const total = (dataItem.subtotal - (dataItem.cuota || 0))
        setNestedValue('total', dataItem, total, true)
      } else {
        setNestedValue('total', dataItem, '', true)
      }
    },
    calculateTotalConImpuesto: function (dataItem, save) {
      if (this.isNotFalsy(dataItem.total) && this.isNotFalsy(dataItem.Taxes)) {
        const total = dataItem.total || 0
        dataItem.Taxes.forEach(tax => setNestedValue('cuota', tax, total * (tax.TaxRate || 0) / 100))
        const cuotaImpuesto = dataItem.Taxes.map(tax => tax.cuota || 0).reduce((acc, x) => acc + x, 0)
        const totalConImpuesto = this.hasOperationType ? total : total + cuotaImpuesto
        setNestedValue('totalConImpuesto', dataItem, totalConImpuesto, true)
      } else {
        setNestedValue('totalConImpuesto', dataItem, '', true)
      }
      if (typeof save === 'function') {
        save(true)
      }
    },
    formatNumberWithDefault: function (number, format = 'currency_8', vdefault = ' - ') {
      if (this.isFalsy(number)) {
        return vdefault
      }
      return i18n.n(number, format)
    },
    taxValue: function (option) {
      return option
    },
    isNotFalsy: function (value) {
      if (Array.isArray(value)) {
        return value.length && value.some(x => this.isNotFalsy(x))
      }
      return ![undefined, null, false, ''].includes(value)
    },
    isFalsy: function (value) {
      return !this.isNotFalsy(value)
    },
    goPorductCreation: function () {
      this.$store.dispatch('app/enterMode', 1)
      this.$router.push({ 
        name: 'masters/products/details',
        params: { id: -1, idCliente: this.idCliente }
      })
    } 
  }
}
</script>
<style>
.k-animation-container.k-animation-container-relative.k-animation-container-shown {
  z-index: 9999;
}
</style>
<style scoped>
::v-deep .el-input__count .dark {
  @apply text-darkblue-100 mt-1;
  background-color: transparent;
}
::v-deep .el-input__count {
  @apply mt-1;
  background-color: transparent;
}

@media (min-width: 1024px) {
  ::v-deep .lg\:max-w-detail {
    max-width: unset;
  }
}
</style>
